module.exports = __webpack_public_path__ + "img/des_distanceday_2.b93bde4a.jpg";